import { Component } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { AlertController } from "ionic-angular";
import { NavController, NavParams } from "ionic-angular";
import { ModalController } from "ionic-angular";
import { Observable } from "rxjs/Observable";
import { ListComponent } from "../../components/listcomponent/listcomponent";
import { PledgeStatus } from "../../models/interfaces/pledgestatus.model";
import { Settings } from "../../models/interfaces/settings.model";
import { Status } from "../../models/interfaces/status.model";
import { Member } from "../../models/interfaces/member.model";
import { DbserviceProvider } from "../../providers/dbservice/dbservice";
import { ValidationserviceProvider } from "../../providers/dbservice/validationservice";
import { ConfigService } from '../../providers/dbservice/configservice';

@Component({
  selector: "page-guest_update",
  templateUrl: "guest_update.html",
})
export class GuestUpdatePage {
  private dataFromOtherPage = null;
  private hasUpdAttendanceAccess: boolean = false;
  private gt_id: number;
  private guestForm: FormGroup;
  private guest;
  private hl_id: number;
  private pledgestatus$: Observable<PledgeStatus[]>;
  private status$: Observable<Status[]>;
  private gt_amount: number;
  private guestfee$: Settings[];
  private tmpguestfee$: Settings[];
  private ps_id: number;
  private ps_name: string;
  private styleName: string ="";
  private id: string;

  constructor(private configService: ConfigService,public navCtrl: NavController, public navParams: NavParams,public alertCtrl: AlertController,
              private formBuilder: FormBuilder, private db: DbserviceProvider, public modalCtrl: ModalController,
  ) {
    console.log("GuestUpdatePage constructor :this.navParams ");
    console.log("GuestUpdatePage constructor :this.navParams ", this.navParams);
    this.styleName=this.configService.getConfig("STYLENAME");
    
    this.guestForm = this.formBuilder.group({
      "hl_runno": ["", [Validators.required, Validators.min(1), Validators.max(9999)]],
      "gt_amount": "",
      "gt_name": ["", [Validators.required]],
      "gt_comment": [""],
      "gt_contact_mobile": ["+65", ""],
      "ps_id": ["", [Validators.required]],
      "st_id": ["", [Validators.required]],
      "ps_name": ["", [Validators.required]],
    });

    this.hl_id = this.navParams.get("guest").hl_id;
    this.gt_id = this.navParams.get("guest").gt_id;
    this.guestForm.controls.hl_runno.setValue(this.navParams.get("guest").hl_runno);
    this.guestForm.controls.gt_amount.setValue(this.navParams.get("guest").gt_amount);
    this.guestForm.controls.gt_name.setValue(this.navParams.get("guest").gt_name);
    this.guestForm.controls.gt_comment.setValue(this.navParams.get("guest").gt_comment);
    this.guestForm.controls.gt_contact_mobile.setValue(this.navParams.get("guest").gt_contact_mobile);
    this.guestForm.controls.ps_id.setValue(Number(this.navParams.get("guest").ps_id));
    this.guestForm.controls.st_id.setValue(this.navParams.get("guest").st_id);
    this.guestForm.controls.ps_name.setValue(this.navParams.get("guest").ps_name);

    this.pledgestatus$ = this.db.dbCol({
      "action": "select", "mapObject": "pledge_status",
      "sqlExtended": " order by pledge_status.ps_order",
    });

    this.status$ = this.db.dbCol({
      "action": "select", "mapObject": "status",
      "sqlExtended": " where st_byfee_flg=1 order by status.st_order",
    });

    this.db.dbCol({
      "action": "select", "mapObject": "settings",
      "sqlExtended": " where se_class = 'Guest' and se_key_name like '%Guest%' order by settings.se_order"
    }).subscribe((ret) => {
      this.guestfee$ = ret;
      this.tmpguestfee$ = this.guestfee$.filter(data => Number(data.se_default_flg) === Number(1));
      console.error("this.guestfee$",this.guestfee$);
      console.error("ret",ret);

    });

  }

  private changeCategory(_st_id) {
    console.log("GuestAddPage changeCategory");

    this.tmpguestfee$ = this.guestfee$.filter(data => Number(data.st_id) === Number(_st_id));
    this.gt_amount=Number(this.tmpguestfee$[0].se_key_value);

  }

  private deleteGuest(id: any) {
    console.log("GuestUpdatePage deletePledge");
    this.showConfirm("Guest", "Do you want to delete the Guest?", id);
  }

  private showConfirm(title: string, message: string, id: string) {
    console.log("GuestUpdatePage showConfirm");
    let confirm = this.alertCtrl.create({
      "buttons": [
        {
          "handler": () => {
            this.db.dbCol({
              "action": "dml", "mapObject": "dml",
              "query": "DELETE FROM guest WHERE gt_id=" + this.gt_id,
            })
              .subscribe((ret) => {
                this.navCtrl.pop();
              });
          },
          "text": "Yes",
        },
        {
          "handler": () => {},
          "text": "No",
        },
      ],
      "message": message,
      "title": title,
    });
    confirm.present();
  }

  private callback = (data) => {
    this.dataFromOtherPage = data;
    console.log("data received from other page", this.dataFromOtherPage);
  }

  private ionViewWillEnter() {
    console.log("GuestUpdatePage ionViewWillEnter");
    this.onInitPage();
    
  }

  private onInitPage() {
    console.log("GuestUpdatePage onInitPage");
  }

  private openOtherPage() {
    this.navCtrl.push("OtherPage", {
      "callback": this.callback,
    });
  }


  private ngOnDestroy() {
    console.log("GuestUpdatePage ngOnDestroy");
  }

  private goback() {
    console.log("GuestUpdatePage goback");
    this.navCtrl.pop();
  }

  private updateGuest(id: string, value: any) {
    console.log("GuestUpdatePage updateGuest");
    const formValues: any = {
      "gt_id": this.navParams.get("guest").gt_id,
      "hl_id": this.navParams.get("guest").hl_id,
      "ps_id": value.ps_id,
      "st_id": value.st_id,
      "gt_name": value.gt_name,
      "gt_comment": value.gt_comment,
      "gt_contact_mobile": value.gt_contact_mobile,
      "gt_amount": value.gt_amount,

    };
    this.db.dbCol({ "action": "update", "mapObject": "guest", ...formValues })
      .subscribe((ret) => {
        this.navCtrl.pop();
      });
  }
}



// WEBPACK FOOTER //
// ./src/components/attendancecomponent/guest_update.ts